export const formatListToMap = (list) => {
  const map = {};
  list.forEach((item) => {
    map[item.id] = item;
  });
  return map;
};

// Oznaka neaktivnog zaposlenog u administrativnim ekranima; zvanična štampa
// (Liste poslovnih procesa, Formular rizika) ispisuje samo ime i prezime
export const INACTIVE_SUFFIX = " (nije više aktivan)";

export const withoutInactiveSuffix = (label) => {
  if (label === null || label === undefined) return "";
  const text = String(label);
  return text.endsWith(INACTIVE_SUFFIX)
    ? text.slice(0, -INACTIVE_SUFFIX.length)
    : text;
};

export const calculateProcessOwnersNames = (list, des) => {
  if (!list || !list.length) {
    return [];
  }
  if (list.length) {
    if (list[0].label) {
      return list;
    } else {
      const names = list.map((owner) => {
        const worker = des.find((des) => {
          return des.id === owner.employee_id;
        });
        if (worker)
          return {
            value: worker,
            label: worker?.name,
            isDisabled: undefined,
          };
        // vlasnik koji više nije aktivan: ostaje prikazan iz postojeće reference,
        // ne nudi se u listi za izbor; uklanja se tek svesnom izmenom
        const name = `${owner.first_name || ""} ${owner.last_name || ""}`.trim();
        if (!name) return undefined;
        const label = `${name} (nije više aktivan)`;
        return {
          value: { ...owner, id: owner.employee_id, name: label },
          label,
          isDisabled: undefined,
        };
      });

      return names.filter((name) => name);
    }
  }
};
